import { getColor } from "../../ui";
// TODO: Create a variant for flat or are we using flat everywhere?
export default function Badge({label, color, variant = 'flat', size='md', compact}) {
    const colorClassString =  getColor(color);
    return (
        <span className={`inline-flex items-center rounded-md bg-${colorClassString}-200 ${compact ? 'p-1' : 'px-2 py-1'} text-${size} font-bold text-${colorClassString}-500 ${variant !== 'flat' && `ring-1 ring-inset ring-${colorClassString}-500/10`}`}>
          {label}
        </span>
    )
  }
  